import React from "react";
import { VERIFICATION_STATUS } from "../../constants/agentTenderChoices";

// Trust badge for an agent tender.
//
// Brief Rule 2: the "Club Verified" tooltip text is FIXED and must not be
// reworded. It means only that the club confirmed this need and this agent as
// its channel on the platform. Copy must follow the UI-COPY.md §7 blacklist.
// V2 design grammar: verified = soft-green pill with the shield-check glyph;
// unverified = quiet bordered pill; superseded/revoked keep their warn tones.
const CONFIG = {
  [VERIFICATION_STATUS.CLUB_VERIFIED]: {
    label: "Club Verified",
    className: "bg-[#ECFDF5] text-[#047857] font-bold",
    tooltip:
      "This club has confirmed this need and this agent as its channel on the platform.",
    showCheck: true,
  },
  [VERIFICATION_STATUS.UNVERIFIED]: {
    label: "Unverified",
    className: "bg-[#F8FAFC] border border-[#E2E8F0] text-[#64748B] font-semibold",
    tooltip: "The club has not yet confirmed this need on the platform.",
    showCheck: false,
  },
  [VERIFICATION_STATUS.SUPERSEDED]: {
    label: "Superseded",
    className: "bg-yellow-50 text-yellow-700 font-semibold",
    tooltip:
      "Another agent request for the same need has been club-verified.",
    showCheck: false,
  },
  [VERIFICATION_STATUS.REVOKED_FRAUD]: {
    label: "Revoked",
    className: "bg-red-50 text-red-600 font-semibold",
    tooltip: "This request was removed by the platform.",
    showCheck: false,
  },
};

// Shield-with-check glyph from the design boards.
const ShieldCheckIcon = () => (
  <svg
    width="11"
    height="11"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 2l7 3v6c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V5z" />
    <path d="M9 12l2 2 4-4" />
  </svg>
);

const ClubVerifiedBadge = ({ status, className = "" }) => {
  const cfg = CONFIG[status] || CONFIG[VERIFICATION_STATUS.UNVERIFIED];
  return (
    <span
      title={cfg.tooltip}
      className={`inline-flex items-center gap-1 px-[9px] py-[3px] rounded-full text-[11px] capitalize ${cfg.className} ${className}`}
    >
      {cfg.showCheck && <ShieldCheckIcon />}
      {cfg.label}
    </span>
  );
};

export default ClubVerifiedBadge;
